import { useSearchParams } from 'react-router-dom';
import { METRIC_KEY } from '@/consts/searchKeys';
import { Nullable } from '@/types/generic';
import { NestedObject } from '@/types/object';
import { useDeepEffect } from './useDeepEffect';
import { useResetSelectionLayer } from './useResetSelectionLayer';

export const useAutoResetSelectionLayer = (eventsFilterParams: Nullable<NestedObject>) => {
  const resetSelectionLayer = useResetSelectionLayer();
  const [searchParams] = useSearchParams();
  const metricKey = searchParams.get(METRIC_KEY);

  useDeepEffect(resetSelectionLayer, [eventsFilterParams, metricKey]);
};
